<template>
  <div class="huidingbu"></div>
</template>

<script>
export default {
  name: "Backtop",
  data() {
    return {
    };
  },
  mounted(){
    jQuery.fn.goToTop = function() {
        // 鍒ゆ柇濡傛灉绐楀彛婊氬姩璺濈灏忎簬0锛岄殣钘忔寜閽�
        if($(window).scrollTop() < 0) {
            $('.huidingbu').hide();
        }

        // 绐楀彛婊氬姩鏃讹紝鍒ゆ柇褰撳墠绐楀彛婊氬姩璺濈

        $(window).scroll(function() {
            if($(this).scrollTop() > 600) {
                $('.huidingbu').fadeIn();
            } else {
                $('.huidingbu').fadeOut();
            }
            
            if($(document).scrollTop() >= $(document).height() - $(window).height() - 100) {
                $('.huidingbu').css("bottom", "4rem")
            } else {
                $('.huidingbu').css("bottom", "0.5rem")
            }
            
            
        });

        // 缁欒繖涓寜閽粦瀹氫竴涓猚lick浜嬩欢
        this.bind('click', function() {
            $('html ,body').animate({
                scrollTop: 0
            }, 500);
            return false;
        });
    };

    //璋冪敤杩欎釜鎻掍欢
    $(function() {
        $('.huidingbu').goToTop();
    });
  }
}
</script>
